import { FC, useState } from "react";
import { ModalPhotoCarousel } from "../ModalPhotoCarousel/ModalPhotoCarousel";
import styles from "./Menu.module.scss";
import { TotalMenu } from "../../utils/pagesData";

interface MenuProps {
  data: TotalMenu;
}

export const Menu: FC<MenuProps> = ({ data }) => {
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [shownPhotoIndex, setShownPhotoIndex] = useState(0);

  return (
    <>
      {showPhotoModal && (
        <ModalPhotoCarousel
          photos={data.images}
          photoIndex={shownPhotoIndex}
          setPhotoIndex={setShownPhotoIndex}
          onClose={() => setShowPhotoModal(false)}
        />
      )}
      <div id={data.id} className={styles.container}>
        <div className={styles.content}>
          <div className={styles.title}>{data.title}</div>
          <div className={styles.menuItems}>
            {data.images.map((src, ind) => {
              return (
                <div key={ind} className={styles.card}>
                  <img
                    src={src}
                    draggable={false}
                    className={styles.imgMenu}
                    onClick={() => {
                      setShownPhotoIndex(ind);
                      setShowPhotoModal(true);
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
